// src/components/ExcursionBookingReport.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Box, Button, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Alert } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const ExcursionBookingReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchReport = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/reports/excursion-bookings');
        setReportData(response.data);
      } catch (err) {
        setError('Failed to fetch report data.');
      } finally {
        setLoading(false);
      }
    };
    fetchReport();
  }, []);

  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/reports/excursion-bookings?export=true', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `excursion_booking_report.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      alert('Failed to export data.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5">Excursion Bookings</Typography>
        <Button onClick={handleExport} disabled={loading || reportData.length === 0} variant="outlined" startIcon={<DownloadIcon />}>Export</Button>
      </Box>

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}
      
      <TableContainer sx={{ maxHeight: 400 }}>
        <Table stickyHeader size="small">
          <TableHead><TableRow><TableCell>Participant Name</TableCell><TableCell>Excursion</TableCell><TableCell>Booking Time</TableCell></TableRow></TableHead>
          <TableBody>
            {reportData.map((row) => (
              <TableRow key={row.ParticipantID} hover>
                <TableCell>{row.FullName}</TableCell>
                <TableCell>{row.SiteName}</TableCell>
                <TableCell>{new Date(row.PaymentTime).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ExcursionBookingReport;